import { render, staticRenderFns } from "./currentWare.vue?vue&type=template&id=d39d7920&scoped=true&"
import script from "./currentWare.vue?vue&type=script&lang=js&"
export * from "./currentWare.vue?vue&type=script&lang=js&"
import style0 from "./currentWare.vue?vue&type=style&index=0&id=d39d7920&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39d7920",
  null
  
)

export default component.exports